import { Expose, Type } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { FsNotifyChannel } from './notify';
import { OrganizationNotifyType } from './organization-notify-type';

export class FsNotifySubscriber extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => FsNotifyChannel)
  public channel: FsNotifyChannel;

  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  @Type(() => Date)
  public updatedTimestamp: Date;

  @Expose()
  public phoneNumber: string;

  @Expose()
  public optIn: boolean;

  @ExposeRawData()
  public description: any;

  @Expose()
  @Type(() => OrganizationNotifyType)
  public organization: OrganizationNotifyType;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
